import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import SpotifyWebApi from "spotify-web-api-node";
import TrackSearchResult from "./TrackSearchResult";
import Player from "./Player";
import axios from "axios";
import SpotifyLogo from "./images/logo512.png";
import micIcon from "./images/mic.svg";

const spotifyApi = new SpotifyWebApi({
  clientId: "d787b9a91de6426d9daba4662fc62525",
});

export default function Dashboard({ code }) {
  const accessToken = useAuth(code);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [playingTrack, setPlayingTrack] = useState();
  const [lyrics, setLyrics] = useState();
  const [showLyrics, setShowLyrics] = useState(false);

  const handleShowLyricsToggler = () => {
    setShowLyrics(!showLyrics);
  };

  function chooseTrack(track) {
    setPlayingTrack(track);
  }

  useEffect(() => {
    if (!playingTrack) return;

    axios
      .get(
        "https://spotify-karaoke-serverapi-production.up.railway.app/lyrics",
        {
          params: {
            track: playingTrack.title,
            artist: playingTrack.artist,
          },
        }
      )
      .then((res) => {
        setLyrics(res.data.lyrics);
      })
      .catch((err) => console.log(err));
  }, [playingTrack]);

  useEffect(() => {
    if (!accessToken) return;
    spotifyApi.setAccessToken(accessToken);
  }, [accessToken]);

  useEffect(() => {
    if (!search) return setSearchResult([]);
    if (!accessToken) return;

    let cancel = false;

    spotifyApi.searchTracks(search).then((res) => {
      if (cancel) return;
      setSearchResult(
        res.body.tracks.items.map((track) => {
          const smallestAlbumCover = track.album.images.reduce(
            (smallest, image) => {
              if (image.height < smallest.height) return image;
              return smallest;
            },
            track.album.images[0]
          );
          return {
            artist: track.artists[0].name,
            title: track.name,
            uri: track.uri,
            albumCover: smallestAlbumCover.url,
          };
        })
      );
    });

    return () => (cancel = true);
  }, [search, accessToken]);

  return (
    <div
      id="C-Container"
      className="flex min-h-screen mb:flex-col mb:max-h-screen mb:relative"
      style={{ minWidth: 250 }}
    >
      <div
        id="C-1"
        className="flex-none border-r border-slate-800 w-96 flex-shrink px-3 py-3 max-h-screen mb:w-full"
      >
        <div id="header-logo-container" className="flex">
          <div className="flex my-5 mx-2 mb:mx-auto">
            <img
              src={SpotifyLogo}
              className="basis-5 w-9 h-9 m-auto"
              alt="spotify-logo"
            />
            <h1 className="flex-grow m-auto pl-2 text-2xl font-bold">
              <span className="text-green-500">Spotify</span>&nbsp;Karaoke
            </h1>
          </div>
        </div>
        <input
          type="search"
          placeholder="What do you want to listen to?"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="text-black px-3 py-2 rounded-sm placeholder:italic placeholder:text-slate-400 placeholder: text-xs w-full"
        />
        <div
          id="search-result-container"
          className="overflow-y-auto py-3 my-4 h-87 mb:h-74vh mb:pb-16"
        >
          {searchResult.map((track) => (
            <TrackSearchResult
              track={track}
              key={track.uri}
              chooseTrack={chooseTrack}
            />
          ))}
        </div>
      </div>
      <div
        id="C-2"
        className="flex-1 w-72 flex flex-col max-h-screen mb:w-full"
      >
        <div
          style={{ whiteSpace: "pre-wrap" }}
          className="my-7 px-2 overflow-y-auto text-center flex-grow pb-8 mb:hidden"
        >
          {lyrics ? (
            lyrics
          ) : (
            <div className="text-center pt-56">
              <img
                src={SpotifyLogo}
                className="w-14 mx-auto"
                alt="spotify-logo"
              />
              <h1 className="pt-4 text-2xl font-bold">Spotify Karaoke</h1>
            </div>
          )}
        </div>
        <button
          className="absolute bottom-28 right-8 hidden mb:block z-50 bg-green-500 p-2 rounded-lg active:bg-green-700 hover:bg-green-600"
          onClick={handleShowLyricsToggler}
        >
          <img src={micIcon} alt="lyrics button" className="invert w-6" />
        </button>
        <div className="flex-none mb:absolute mb:w-full mb:bottom-0">
          <Player
            accessToken={accessToken}
            trackUri={playingTrack?.uri}
            setPlayingTrack={setPlayingTrack}
          />
        </div>
      </div>
      <div
        id="mobile-lyrics-container"
        className={`hidden mb:absolute mb:h-screen mb:w-full top-0 max-h-[100vh] z-50  bg-slate-900 ${
          showLyrics && `mb:block`
        }`}
      >
        <div
          id="x-button-wrapper"
          className="absolute top-0 w-full bg-slate-900"
          style={{ height: "2rem" }}
        >
          <button
            className="text-4xl rotate-45 active:opacity-70 right-5 absolute"
            onClick={handleShowLyricsToggler}
          >
            +
          </button>
        </div>
        <div
          id="fullscreen-lyrics"
          className="whitespace-pre-wrap h-screen text-center py-10 px-8"
          style={{ height: "100vh", overflow: "auto" }}
        >
          {lyrics && lyrics}
        </div>
      </div>
    </div>
  );
}
